var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.403,
    height: 45.328,
    viewBox: "0 0 45.403 45.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2474",
    "data-name": "Rectangle 2474",
    width: 45.328,
    height: 45.403,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712",
    transform: "translate(45.404) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3280",
    "data-name": "Group 3280",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M45.328,9.357A3.957,3.957,0,0,0,41.375,5.4H38.589V2.735A2.738,2.738,0,0,0,35.852,0h-.628a2.738,2.738,0,0,0-2.736,2.735V5.4H12.838V2.735A2.738,2.738,0,0,0,10.1,0H9.474A2.738,2.738,0,0,0,6.739,2.735V5.4H3.952A3.956,3.956,0,0,0,0,9.357v5.39a3.928,3.928,0,0,0,1.3,2.911A3.5,3.5,0,0,0,0,20.37V41.883A3.524,3.524,0,0,0,3.521,45.4H41.807a3.524,3.524,0,0,0,3.521-3.52V20.37a3.5,3.5,0,0,0-1.3-2.711,3.928,3.928,0,0,0,1.3-2.911ZM34.133,7.05V2.735a1.093,1.093,0,0,1,1.091-1.091h.628a1.093,1.093,0,0,1,1.091,1.091V9.982a1.093,1.093,0,0,1-1.091,1.092h-.628a1.093,1.093,0,0,1-1.091-1.092Zm-25.75,0V2.735A1.092,1.092,0,0,1,9.474,1.644H10.1a1.093,1.093,0,0,1,1.091,1.091V9.982A1.093,1.093,0,0,1,10.1,11.074H9.474A1.093,1.093,0,0,1,8.384,9.982Zm.651,36.71H3.521a1.879,1.879,0,0,1-1.877-1.877V38.134H9.035Zm0-6.448H1.644V31.418H9.035Zm0-6.716H1.644V24.7H9.035Zm0-6.715H1.644V20.37a1.874,1.874,0,0,1,1.364-1.8,3.923,3.923,0,0,0,.944.126H9.035Zm8.726,19.879h-7.9V38.134h7.9Zm0-6.448h-7.9V31.418h7.9Zm0-6.716h-7.9V24.7h7.9Zm0-6.715h-7.9V18.7h7.9Zm8.727,19.879h-7.9V38.134h7.9Zm0-6.448h-7.9V31.418h7.9Zm0-6.716h-7.9V24.7h7.9Zm0-6.715h-7.9V18.7h7.9Zm8.727,19.879h-7.9V38.134h7.9Zm0-6.448h-7.9V31.418h7.9Zm0-6.716h-7.9V24.7h7.9Zm0-6.715h-7.9V18.7h7.9Zm8.47,18a1.879,1.879,0,0,1-1.877,1.877H36.036V38.134h7.648Zm0-4.571H36.036V31.418h7.648Zm0-6.716H36.036V24.7h7.648Zm0-6.715H36.036V18.7h5.339a3.915,3.915,0,0,0,.944-.126,1.874,1.874,0,0,1,1.365,1.8Zm0-9.133a2.326,2.326,0,0,1-2.309,2.308H3.952a2.325,2.325,0,0,1-2.308-2.308V9.357A2.311,2.311,0,0,1,3.952,7.05H6.739V9.982a2.739,2.739,0,0,0,2.735,2.736H10.1a2.739,2.739,0,0,0,2.736-2.736V7.05H32.489V9.982a2.739,2.739,0,0,0,2.736,2.736h.628a2.739,2.739,0,0,0,2.736-2.736V7.05h2.786a2.311,2.311,0,0,1,2.309,2.308Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCalendarIcon);
export default __webpack_public_path__ + "static/media/whiteCalendarIcon.60db1f728ae59e04a3da60c6e460fba8.svg";
export { ForwardRef as ReactComponent };